import {RestService} from './_rest.service'
import {REST_API_END_POINTS} from './constants'
import {ComponentIssue} from "../api";

export class ComponentIssueService extends RestService<ComponentIssue> {
    constructor(url: string) {
        url ? super(url) : super(REST_API_END_POINTS.COMPONENT_ISSUE)
    }
}
